import * as _ from 'lodash';
import { PersonType } from '../../common/constants/person-type.enum';
import { DynamicQueryEvent } from 'common/dynamicquery/dynamic-query-events.factory';

/**
 * MessageBase model
 * @param message
 * @constructor
 */

class ChatMessageBase {
  public type;
  public messages;
  public Created?: string;

  static isAgent(message) {
    return message.PersonType === PersonType.Operator || message.PersonType === PersonType.OperatorTranslated;
  }

  static isVisitor(message) {
    return message.PersonType === PersonType.Visitor || message.PersonType === PersonType.VisitorTranslated;
  }

  static isSystem(message) {
    return message.PersonType === PersonType.System;
  }

  static wrap(event: Partial<DynamicQueryEvent>): ChatMessageBase {
    return new ChatMessageBase(event.data);
  }

  static wrapAll(eventList) {
    return _.map(eventList, ChatMessageBase.wrap);
  }

  constructor(message) {
    _.assign(this, message);
  }
}

export { ChatMessageBase };
